import { generateSimpleAction } from 'utils/actionHelpers/actionHelpers'

export const RESET_STATUS = 'RESET_STATUS'
export const resetStatus = generateSimpleAction(RESET_STATUS)
